// extracted by mini-css-extract-plugin
export default {"media-left":"MediaLeft--media-left--EzQvk","mediaLeft":"MediaLeft--media-left--EzQvk"};